import React, {useEffect, useRef} from 'react';
import {Navigate, Route, Routes} from "react-router-dom"
import Search from "./pages/Search";
import ShowInstrument from "./pages/show_instrument";
import EditInstrument from "./pages/edit_instrument";
import NewInstrument from "./pages/new_instrument";
import Header from "./components/Header/Header";
import {headerTheme} from "./style/header-theme";
import {ThemeProvider} from "@mui/material";
import Footer from "./components/Footer/Footer";
import styles from "./App.module.scss";
import {BasicAuthProvider} from "./util/BasicAuth";
import {RequireBasicAuth} from "./util/RequireBasicAuth";
import {BasicLogin} from "./pages/BasicLogin";
import {mainTheme} from "./style/main-theme";
import EditGroups from "./pages/EditGroups";
import {State, Status} from "./store/state";
import {fetchTags} from "./store/reducers/tags";
import {fetchInstruments} from "./store/reducers/instruments";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "./store";
import CircularIndeterminate from "./components/CircularIndeterminate/CircularIndeterminate";
import {loggedIn} from "./store/reducers/authenticated";
import AlertMessage from "./components/AlertMessage/AlertMessage";

export default function App() {
  const dispatch = useDispatch<AppDispatch>();
  const tagsStatus = useSelector((state: State) => state.tags.status);
  const instrumentsStatus = useSelector((state: State) => state.instruments.status);
  const fetchDataTriggered = useRef(false);

  useEffect(() => {
    // effect is triggered twice in dev mode with React.StrictMode
    if (fetchDataTriggered.current) return;
    if (tagsStatus === Status.IDLE) dispatch(fetchTags())
    if (instrumentsStatus === Status.IDLE) dispatch(fetchInstruments())
    fetchDataTriggered.current = true;
  }, [tagsStatus, instrumentsStatus, dispatch]);

  useEffect(() => {
    if (localStorage.getItem("isAuthenticated") === "true") dispatch(loggedIn());
  }, [dispatch]);

  const isLoading = tagsStatus === Status.LOADING || instrumentsStatus === Status.LOADING;

  return (
      <>
        <AlertMessage/>
        <div className={styles['layout-container']} data-color-mode="light">
          <BasicAuthProvider>
            <ThemeProvider theme={headerTheme}>
              <Header/>
            </ThemeProvider>
            <ThemeProvider theme={mainTheme}>
              <main role="main">
                <div className={styles['layout-content']}>
                  {isLoading ? <CircularIndeterminate/> :
                      <Routes>
                        <Route path="/" element={<Navigate to="/search"/>}/>
                        <Route path="/search" element={<Search/>}/>
                        <Route path="/editGroups" element={<EditGroups/>}/>
                        <Route path="/show/:instrumentId" element={<ShowInstrument/>}/>
                        <Route path="/edit/:instrumentId"
                               element={<RequireBasicAuth> <EditInstrument/> </RequireBasicAuth>}/>
                        <Route path="/new"
                               element={<RequireBasicAuth> <NewInstrument/> </RequireBasicAuth>}/>
                        <Route path="/new/:instrumentId"
                               element={<RequireBasicAuth> <NewInstrument/> </RequireBasicAuth>}/>
                        <Route path="/login" element={<BasicLogin/>}/>
                      </Routes>
                  }
                </div>
                <Footer/>
              </main>
            </ThemeProvider>
          </BasicAuthProvider>
        </div>
        <a id="scrollTopButton-image" href="#" className={styles['scroll-top-button']}/>
      </>
  );
}
